import { properties } from '@/utils/properties';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface AdmUsuario {
  id_usuario?: number;
  nombre_usuario: string;
  email?: string;
  password?: string;
  activo?: number;
  tipo?: number;
  id_perfil?: number;
  id_colaborador?: number;
  colaborador?: {
    id_colaborador: number;
    nombre_colaborador: string;
    apellidos: string;
  };
  perfil?: {
    id_perfil: number;
    nombre_perfil: string;
  };
}

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
}

@Injectable({
  providedIn: 'root'
})
export class AdmUsuarioService {

  private baseUrl = properties.URL_ADMIN + 'adm-usuarios';

  constructor(private http: HttpClient) { }

  /**
   * Obtener todos los usuarios
   */
  getAll(): Observable<AdmUsuario[]> {
    return this.http.get<AdmUsuario[]>(this.baseUrl, properties.httpOptions);
  }

  /**
   * Obtener un usuario específico
   */
  getById(id: number): Observable<ApiResponse<AdmUsuario>> {
    return this.http.get<ApiResponse<AdmUsuario>>(`${this.baseUrl}/${id}`, properties.httpOptions);
  }

  /**
   * Crear nuevo usuario
   */
  create(usuario: AdmUsuario): Observable<ApiResponse<AdmUsuario>> {
    return this.http.post<ApiResponse<AdmUsuario>>(this.baseUrl, usuario, properties.httpOptions);
  }

  /**
   * Actualizar usuario
   */
  update(id: number, usuario: AdmUsuario): Observable<ApiResponse<AdmUsuario>> {
    return this.http.put<ApiResponse<AdmUsuario>>(`${this.baseUrl}/${id}`, usuario, properties.httpOptions);
  }

  /**
   * Eliminar (desactivar) usuario
   */
  delete(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`, properties.httpOptions);
  }

  /**
   * Cambiar contraseña de usuario
   */
  changePassword(id: number, payload: { currentPassword: string, newPassword: string }): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(`${this.baseUrl}/${id}/change-password`, payload, properties.httpOptions);
  }
}
